import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import type { ProvidedProfile } from '@/features/jobs/info-gathering/supporting-item-input'

/**
 * Props for {@link SpousalInfoSupportingItemInput}.
 */
export type SpousalInfoSupportingItemInputProps =
  ModelProps<SpousalInfoSupportingItemInput> & { type: 'SpousalInfo' }

/**
 * Supporting item input for spousal information.
 */
export class SpousalInfoSupportingItemInput extends Model<SpousalInfoSupportingItemInput> {
  /**
   * The provided profile, if any.
   */
  @observable.struct accessor provided: ProvidedProfile | null = null
}
